function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0,
  y1: 20.89,
  x2: 52.95,
  y2: 20.89,
  gradientTransform: "translate(0 41.28) scale(1 -1)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#21deff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#21deff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#21deff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#21deff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#21deff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#21deff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#21deff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient1",
  x1: 24.69,
  y1: 27.05,
  x2: 52.95,
  y2: 27.05,
  gradientTransform: "translate(0 41.28) scale(1 -1)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#44b044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#44b044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#44b044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#44b044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#44b044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#44b044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#44b044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#44b044"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient2",
  x1: 7.04,
  y1: 20.96,
  x2: 56.76,
  y2: 20.96,
  gradientTransform: "translate(0 41.28) scale(1 -1)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3774ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#3774ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#3774ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#3774ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#3774ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3774ff"
})));

var SvgWebex = function SvgWebex(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 56.76 40.78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    d: "M38.55,0c-1.97-.02-3.92.48-5.64,1.44-1.78.9-3.32,2.19-4.52,3.79l-5.72,15.36c-.1.57-.23,1.14-.4,1.7-.08.32-.16.56-.25.88-.48,1.59-1.04,3.15-1.69,4.68-.49.88-1.21,1.94-2.5,1.69l-.49-.25c-.81-.61-1.44-1.41-1.85-2.33-1.09-2.02-1.96-4.16-2.58-6.37-.8-2.77-1.37-5.59-1.69-8.46,0-1.3-.36-2.58-1.02-3.71-.44-.59-.99-1.08-1.62-1.45-.83-.5-1.77-.78-2.73-.81-1.03-.03-2.06.19-2.99.65-.86.48-1.57,1.19-2.05,2.05C.26,9.69-.02,10.67,0,11.67c.02.38.07.76.16,1.13.32,3.23,1.69,13.23,6.29,20.81,0,0,3.79,7.33,11.93,7.17,1.96-.05,3.88-.52,5.64-1.37,1.77-.83,3.32-2.07,4.52-3.62l3.31-7.33,2.42-7.74.24-1.21c.48-2.04,1.12-4.04,1.94-5.97.26-.8.73-1.51,1.37-2.05l.08-.08c.58-.29,1.28-.19,1.77.24.3.21.55.49.73.81.25.32.4.65.65.96.39.66.73,1.34,1.02,2.05.25.57.55,1.13.89,1.65.05,0,.08.04.08.08.55.6,1.21,1.08,1.94,1.44.72.39,1.52.58,2.33.56.74,0,1.48-.14,2.18-.4s1.33-.68,1.85-1.21c.47-.57.88-1.19,1.21-1.85.25-.7.38-1.44.4-2.18,0-.8-.16-1.6-.48-2.33,0,0-2.18-5.64-5.97-8.47C44.22.97,41.43,0,38.55,0Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.55,0c-1.98,0-3.93.45-5.72,1.29-1.78.89-3.33,2.19-4.52,3.79l-3.62,9.75,7.1,13.63,2.42-7.74.24-1.21c.48-2.04,1.12-4.04,1.94-5.97.26-.8.73-1.51,1.37-2.05l.08-.08c.58-.29,1.28-.19,1.77.24.3.21.55.49.73.81.25.32.4.65.65.96.39.66.73,1.34,1.02,2.05.27.57.59,1.12.95,1.64.05,0,.08.04.08.08.55.6,1.21,1.08,1.94,1.44.72.39,1.52.58,2.33.56.74,0,1.48-.14,2.18-.4s1.33-.68,1.85-1.21c.47-.57.88-1.19,1.21-1.85.25-.7.38-1.44.4-2.18,0-.8-.16-1.6-.48-2.33,0,0-2.18-5.64-5.97-8.47C44.22.97,41.43,0,38.55,0Z",
    style: {
      fill: "url(#linear-gradient1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.35,0c-.48.02-.97.08-1.44.16-3.67.74-6.88,2.96-8.87,6.14.54.13,1.06.35,1.53.65.63.37,1.18.87,1.62,1.45.67,1.12,1.02,2.4,1.02,3.71.34,2.8.88,5.57,1.62,8.29.77-2.99,2.05-5.82,3.79-8.38.2-.3.48-.55.8-.73.17-.1.36-.16.56-.16.34,0,.68.08.97.25.08,0,.08.08.16.08.26.25.5.51.72.8.43.79.81,1.6,1.14,2.43.65,1.77,1.21,4.02,1.21,4.02l1.61,6.45c.56,2.23,1.29,4.41,2.18,6.53,2.5,5.72,6.29,7.33,6.29,7.33,1.87.97,3.93,1.52,6.04,1.61,2.01.09,4-.32,5.81-1.21,1.98-.99,3.72-2.38,5.12-4.1.84-1.15,1.6-2.36,2.25-3.62,1.51-2.98,2.68-6.12,3.47-9.36.55-2.02.98-4.07,1.29-6.14.16-1.02.32-2.05.4-3.07.18-.96.15-1.95-.08-2.9-.07-.16-.07-.33-.15-.49-.49-1.19-1.37-2.19-2.5-2.82-.81-.54-1.77-.83-2.74-.81-.46,0-.92.06-1.37.16,1.04,1.52,1.93,3.14,2.66,4.83.32.74.48,1.53.48,2.33-.02.74-.15,1.48-.4,2.18-.33.66-.73,1.28-1.21,1.85-.5.56-1.14.98-1.85,1.21-.7.26-1.44.4-2.18.41-1,.02-1.98-.26-2.82-.81l-.57,2.17c-.43,1.67-1.02,3.29-1.77,4.84-.4.95-.88,1.87-1.44,2.73-.37.6-.9,1.07-1.54,1.37-.24.07-.48.1-.73.08-.26,0-.52-.09-.73-.25-.43-.36-.77-.8-1.02-1.29-.33-.53-.62-1.08-.88-1.65-.48-1.21-1.29-4.19-1.29-4.19l-.76-3.18-.81-3.14-.56-2.1c-.68-2.88-1.88-5.61-3.55-8.06-1.63-2.31-3.93-4.06-6.6-5C21.15.27,20.05.05,18.93,0h-1.59.01Z",
    style: {
      fill: "url(#linear-gradient2)"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWebex, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "webex.svg";
export { ForwardRef as ReactComponent };